export const GAME_DATA: {
    [key: string]: {
        template: 'V1' | 'V2' | 'V3'
        folder: string
        data?: any
    }
} = {
    /** 人工定制落地页 */
    '1635908887072642|1635908887072643': {
        template: 'V2',
        // local path: /assets/imgs/game/xxcq
        folder: 'xycq',
        data: {
            // 奖励格式, icon: /game/xxcq/awards/[icon].png
            // 奖励格式: message 展示内容
            award: [
                {
                    icon: '豪华礼包',
                    message: '豪华礼包：激活码VIP666'
                },
                {
                    icon: '热血神剑',
                    message: '热血神剑*1'
                },
                {
                    icon: '超级转生丹',
                    message: '超级转生丹*3'
                },
                {
                    icon: '超级转生轮回礼包',
                    message: '超级转生轮回礼包*3'
                },
                {
                    icon: '热血神甲',
                    message: '热血神甲*1'
                },
                {
                    icon: 'boss卷轴自选包',
                    message: 'boss卷轴自选包*5'
                }
            ]
        }
    },
    '6235908887072643|6219309872643': {
        template: 'V3',
        // local path: /assets/imgs/game/xxcq
        folder: 'xycq'
    }
}

export const GAME_DETAIL: Array<{
    gameId: string
    hortationImg: string
    icon1: string
    guideImgs: string
    downloadUrl: string
    H5downloadUrl: string
}> = [
    {
        gameId: '6235908887072643',
        hortationImg: 'https://alifile.iyouhuyu.com/pic/2024-04-24/3c0d8966-52a0-4067-8f79-f3c8f73983d7.png',
        icon1: 'https://alifile.iyouhuyu.com/pic/2024-04-25/3d5f8159-e573-427e-bc92-f748c8b786bf.png',
        guideImgs: 'https://aiyoufile.obs.cn-east-3.myhuaweicloud.com/pic/tutorials3.gif',
        downloadUrl: 'https://init.sdk.v2.dakongy.com/sub_package/6625c49c97177.apk',
        H5downloadUrl: 'https://init.sdk.v2.dakongy.com/game?union=82722&code=gzwebh5'
    },
    {
        gameId: '6219309872643',
        hortationImg: 'https://alifile.iyouhuyu.com/pic/2024-04-24/3c0d8966-52a0-4067-8f79-f3c8f73983d7.png',
        icon1: 'https://alifile.iyouhuyu.com/pic/2024-04-25/3d5f8159-e573-427e-bc92-f748c8b786bf.png',
        guideImgs: 'https://aiyoufile.obs.cn-east-3.myhuaweicloud.com/pic/tutorials3.gif',
        downloadUrl:
            'https://alifile.iyouhuyu.com/apk/20240617/fanmaokeji_xinghaiqishizhitfay_2_20240425100327581_20240617041924738_1.0.0_3159423.apk',
        H5downloadUrl: 'http://h5game.iyouhuyu.com/game/1247/3159423'
    }
]

export const GAME_INFO: {
    backgroundImg: string
    backgroundImgHw: string
    brandId: number
    buttonIndexs: string
    code: string
    ctime: number
    dynamicImg: string
    dynamicImgHw: string
    dynamicIndex: string
    gameId: number
    landingPageStatus: number
    operatorUid: number
    osType: number
    sowingImgs: string
    sowingImgsHw: string
    sowingIndex: string
    suspenButtonIndex: string
    suspenImg: string
    suspenImgHw: string
    title: string
    utime: number
    vedioIndex: string
    vedioPath: string
    vedioPathHw: string
    vedioShot: string
    vedioShotHw: string
} = {
    backgroundImg: 'https://alifile.iyouhuyu.com/pic/2024-04-26/e9e179e2-1c5e-45af-8253-20d6bd48e003.png',
    backgroundImgHw: 'https://alifile-abroad.youximao.com/pic/2024-04-26/e9e179e2-1c5e-45af-8253-20d6bd48e003.png',
    brandId: 42,
    buttonIndexs: '[{"x":"527","y":"35","w":"191","h":"85"},{"x":"143","y":"1113","w":"442","h":"131"}]',
    code: '[{"codeName":"","codeBody":""}]',
    ctime: 1714102895,
    dynamicImg: '',
    dynamicImgHw: '',
    dynamicIndex: '[{"x":"","y":"","w":"","h":""}]',
    gameId: 6219309872643,
    landingPageStatus: 1,
    operatorUid: 3810944661041037983,
    osType: 2,
    sowingImgs: '[]',
    sowingImgsHw: '[]',
    sowingIndex: '[{"x":"","y":"","w":"","h":""}]',
    suspenButtonIndex: '[{"x":"","y":"","w":"","h":""}]',
    suspenImg: '',
    suspenImgHw: '',
    title: '星骸骑士',
    utime: 1714102895,
    vedioIndex: '[{"x":"","y":"","w":"","h":""}]',
    vedioPath: '',
    vedioPathHw: '',
    vedioShot: '',
    vedioShotHw: ''
}
